import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { buildPhoneUsersQueryParams, extractPhoneUsersFilterReference, normalizePhoneUsersResponse, } from '../model/phone-users.model';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const phoneUsersApiUrl = API_ROUTES.qstat.phoneUsers;
const emptyFilterReference = () => ({
    branches: [],
    agentNames: [],
    displayStatuses: [],
});
const initialState = {
    loading: false,
    errorMessage: null,
    asteriskConnected: false,
    phoneUsers: [],
    filterReference: emptyFilterReference(),
    lastUpdated: null,
};
export const getPhoneUsers = createAsyncThunk('realtime/fetch_phone_users', async (args) => {
    const query = args?.query ?? {};
    const params = buildPhoneUsersQueryParams(query);
    const qs = params.toString();
    const url = qs ? `${phoneUsersApiUrl}?${qs}` : phoneUsersApiUrl;
    const res = await axios.get(url);
    return {
        data: res.data,
        captureFilterReference: Boolean(args?.captureFilterReference),
    };
}, { serializeError: serializeAxiosError });
export const realtimeSlice = createSlice({
    name: 'realtime',
    initialState: initialState,
    reducers: {
        clearRealtime(state) {
            state.phoneUsers = [];
            state.filterReference = emptyFilterReference();
            state.errorMessage = null;
            state.asteriskConnected = false;
            state.lastUpdated = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getPhoneUsers.fulfilled, (state, action) => {
            state.loading = false;
            const snapshot = normalizePhoneUsersResponse(action.payload.data);
            state.phoneUsers = snapshot.users;
            state.asteriskConnected = snapshot.asteriskConnected;
            state.lastUpdated = new Date().toISOString();
            state.errorMessage = null;
            if (action.payload.captureFilterReference) {
                state.filterReference = extractPhoneUsersFilterReference(snapshot.users);
            }
        })
            .addMatcher(isPending(getPhoneUsers), (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
            .addMatcher(isRejected(getPhoneUsers), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { clearRealtime } = realtimeSlice.actions;
export default realtimeSlice.reducer;
